import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Collection } from '../../../../collection'
import * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'
import type { State } from '../state'

export const inferAttributesOnGetOrList = store.reducers.extra(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    collection: Collection<TTypeParams>,
  ) =>
    new store.reducers.ExtraReducer({
      on: [
        collection.plugins.apiExecutionPlugin.feature.actions.execute.success,
      ],
      reduce: (state: State<TTypeParams>, action) => {
        if (
          !!state.attributes?.length ||
          collection.plugins.apiExecutionPlugin.canExecute('getAttributes') ||
          !(
            action.data.methodName === 'get' ||
            action.data.methodName === 'list'
          ) ||
          !action.data.response
        ) {
          // If we already have attributes, we don't want to overwrite them. If
          // the API provides explicit attributes, those are authoritative, so
          // inferring would only flash raw entity keys (and could seed the
          // column order with them). Also, if we didn't get response, there's
          // nothing we can infer from.
          return state
        }
        return {
          ...state,
          attributes: ecModels.Attribute.inferFrom(action.data.response),
        }
      },
    }),
)
